import { Cookies } from 'react-cookie';

const cookieDomain = `.${process.env.SITE_DOMAIN}`;
const SID_PATTERN = /^[a-zA-Z0-9_\-.]{1,50}$/;

class Referrer {
  constructor() {
    this.cookies = new Cookies();
  }

  set pid(pid) {
    this.cookies.set('pid', pid, {
      maxAge: 1209600,
      path: '/',
      domain: cookieDomain,
    });
  }

  get pid() {
    return this.cookies.get('pid');
  }

  set subId(subId) {
    let subIdValue = 'default';

    if (subId && SID_PATTERN.test(subId)) {
      subIdValue = subId;
    }

    this.cookies.set('subid', subIdValue, {
      maxAge: 1209600,
      path: '/',
      domain: cookieDomain,
    });
  }

  get subId() {
    return this.cookies.get('subid');
  }

  set site(referrer) {
    if (referrer && referrer.length > 0 && !referrer.includes(process.env.SITE_DOMAIN)) {
      this.cookies.set('ref-site', referrer, {
        maxAge: 31104000,
        path: '/',
        domain: cookieDomain,
      });
    }
  }

  get site() {
    return this.cookies.get('ref-site');
  }

  clean(keys = ['pid', 'subid', 'ref-site']) {
    let keysToClean = keys;

    if (typeof keys === 'string') {
      keysToClean = [keys];
    }

    keysToClean.forEach((key) => {
      this.cookies.remove(key, {
        path: '/',
        domain: cookieDomain,
      });
    });
  }
}

export default new Referrer();
